<template>
  <div class="field email-list">
    <label :for="name">{{label}} <em class="optional" v-if="!required">optional</em><em class="required" v-if="required">*</em></label>
    <div class="input-wrapper">
      <input @keyup.enter.prevent="addTag"
      @keyup.space="addTagKey"
      @keyup.comma="addTagKey"
      @keyup.backspace="handleBackspace"
      v-model="tag"
      type="text"
      :id="name"
      :name="name"
      class="email-list-input">
      <i
        class="add icon yule-icon-circle-plus"
        @click="addTag"
      />
    </div>
    <div class="email-list--input">
      <div class="email-list--item" v-for="(item, index) in newValue" :key="index">
        <span>{{item}}</span><i class="remove icon yule-icon-close-small" @click="removeTag(index)"></i>
      </div>
    </div>
    <p v-if="error" class="validation-message">{{$t(error)}}</p>
  </div>
</template>
<script>

let regex = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/


export default{
  props: {
    label: String,
    classes: Array,
    name: String,
    value: Array,
    required: {
      type: Boolean,
      default: false
    },
  },
  data(){
    return{
      newValue: Array,
      error: "",
      tag: "",
      regex,
      backspace_count: 1
    }
  },
  methods:{
    handleBackspace(){
      if(this.tag == ""){
        if(this.backspace_count == 0){
          this.backspace_count++
        }else{
          this.removeLastTag()
        }
      }else{
        this.backspace_count = 0
      }
    },
    removeLastTag(){
      let index = this.newValue.length - 1
      this.removeTag(index)
    },
    removeTag(index){
      this.newValue.splice(index,1)
    },
    validate(tag){

      return this.regex.test(tag)
    },
    addTagKey(){
      let tag = this.tag
      this.tag = tag.substring(0, tag.length-1)
      this.addTag()
    },
    addTag(){
      if(this.newValue === undefined){
        this.newValue = []
      }
      if(this.tag != ''){
        if(this.validate(this.tag)){
          this.newValue.push(this.tag)
          this.tag = ""
          this.error = ""
        }else{
          this.error = "errors.wrong_email_format"
        }
      }
    }
  },
  created () {
    this.newValue = this.value
  },
  watch: {
    value() {
      this.newValue = this.value
    },
    newValue () {
      this.$emit('input', this.newValue)
    }
  }
}
</script>
<style lang="scss" scoped>
.add {
  position: absolute;
  right: 10px;
  top: 50%;
  bottom: 50%;
  cursor: pointer;
}
.input-wrapper {
  position: relative;
  width: 100%;
}
.email-list--input{
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-content: flex-start;
  max-height: 200px;
  overflow-y: auto;
}
.email-list--item{
  padding: 7px 12px;
  background: $paper;
  border-radius: 3px;
  user-select: none;
  margin-right: 5px;
  color: $ink-dark;
  margin-top: 5px;
}
.remove{
  font-size: 18px;
  display: inline-block;
  vertical-align: bottom;
  margin-left: 4px;
  opacity: .37;
  cursor: pointer;
  &:hover{
    opacity: .69;
  }
}
.email-list-input{
  margin-bottom: 0 !important;
  min-width: 80px;
  border:none;
  outline: none;
  flex-grow: 1;
  min-width: 460px;
}
.validation-message{
  color: #a90014;
}

@media(max-width: 575px) {
  .email-list-input{
    min-width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// EmailList.vue?e26e5f46